import { graphql } from 'src/graphql';

import type { ResultOf } from 'src/graphql';

export const HighlightFields = graphql(`
  fragment HighlightFields on HighlightType @_unmask {
    _id
    _room_id
    start_word {
      start
    }
    end_word {
      start
      end
    }
    quote_preview
    tag_ids
    tags {
      nodes {
        _id
        name
        color
      }
    }
    clip {
      status
      url
      image_urls {
        md
      }
    }
  }
`);

export const RoomHighlights = graphql(
  `
    query RoomHighlights($meetingCode: String!, $roomId: ID!) {
      playbackGetHighlights(meeting_code: $meetingCode, _room_id: $roomId) {
        ...HighlightFields
      }
    }
  `,
  [HighlightFields],
);

export type RoomHighlight = ResultOf<typeof HighlightFields>;
